import { useTranslation } from "react-i18next";

interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
}

export default function StepIndicator({ currentStep, totalSteps }: StepIndicatorProps) {
  const { t } = useTranslation();

  const stepKeys = [
    "tabifoto.booking.step_1",
    "tabifoto.booking.step_2",
    "tabifoto.booking.step_3",
    "tabifoto.booking.step_4",
    "tabifoto.booking.step_5",
  ];

  return (
    <div className="w-full max-w-3xl mx-auto px-6">
      <div className="flex items-center justify-between relative">
        {/* Progress line background */}
        <div className="absolute top-4 left-0 right-0 h-px bg-[#D9D9D9]" />
        {/* Progress line filled */}
        <div
          className="absolute top-4 left-0 h-px bg-[#C8B8A6] transition-all duration-500"
          style={{ width: `${((currentStep - 1) / (totalSteps - 1)) * 100}%` }}
        />

        {stepKeys.slice(0, totalSteps).map((key, idx) => {
          const stepNum = idx + 1;
          const isDone = stepNum < currentStep;
          const isActive = stepNum === currentStep;

          return (
            <div key={idx} className="relative flex flex-col items-center gap-2 z-10">
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-light transition-all duration-300 ${
                  isDone
                    ? "bg-[#C8B8A6] text-white"
                    : isActive
                    ? "bg-[#2C2C2C] text-white"
                    : "bg-[#F7F6F3] border border-[#D9D9D9] text-[#2C2C2C]/30"
                }`}
              >
                {isDone ? (
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-check-line text-sm" />
                  </div>
                ) : (
                  stepNum
                )}
              </div>
              <span
                className={`text-xs tracking-wide whitespace-nowrap transition-colors duration-300 ${
                  isActive ? "text-[#2C2C2C]" : "text-[#2C2C2C]/30"
                }`}
              >
                {t(key)}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
